/* External */
import React from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import SportSectionOtt from '@dtvgo/sport-section';
import '@dtvgo/sport-section/dist/main.css';

/* Utils */
import { CollectionText, getCollectionRedirectUrl, getVrioImageUrl } from '../../utils';
import { history } from '../../state/configureStore';

/* Assets */
import defaultImage from '../../assets/images/CollectionGenericCard.png';

/* Styles */
import './SportSection.scss';

function SportSection({
  collection,
  containerCarouselId,
  containerCarouselType,
}) {
  if (!collection) return null;

  const handleOnClick = () => {
    const redirectUrl = getCollectionRedirectUrl(
      collection,
      containerCarouselId,
      containerCarouselType,
    );

    if (redirectUrl) history.push(redirectUrl);
  };

  return (
    <SportSectionOtt
      className="dtv-webpriv-c-sport-section"
      imageUrl={getVrioImageUrl(collection.cardImages, '1:1', {}) || defaultImage}
      title={collection.title}
      onClick={handleOnClick}
    />
  );
}

SportSection.propTypes = {
  collection: PropTypes.shape({
    title: PropTypes.string,
    cardImages: PropTypes.arrayOf(
      PropTypes.shape({
        ratio: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    sportIds: PropTypes.objectOf(PropTypes.string),
    actions: PropTypes.arrayOf(PropTypes.shape({
      target: PropTypes.string,
      text: PropTypes.oneOf([CollectionText.SPORT_SECTION]),
      type: PropTypes.string,
    })).isRequired,
  }).isRequired,
  containerCarouselId: PropTypes.string.isRequired,
  containerCarouselType: PropTypes.string.isRequired,
};

export default SportSection;
